// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2a8DX","bigColWidth":"Table_bigColWidth__BixVh","biggerColWidth":"Table_biggerColWidth__3an9B","row":"Table_row__2__d9","col":"Table_col__1bZ3I"};